export class ChartValue {
  x: number;
  y: number;
  yLabel: string;
}

export class ChartAxis {
  isPercentage: boolean;
  isPercentageUnit: boolean;
  legend: string;
  min: number;
  max: number;
  unit: string;
}

export class ChartSerie {
  caption: string;
  color: string;
  type: string;
  group: string;
  isCurrentTeam: boolean;
  yValues: ChartValue[];
  legendGroup: string;
}
